import { BaseNavigation } from '~/services/navigation/baseNavigation'
import { TranslationService } from '~/services/Translation'

export class ProfileNavigation extends BaseNavigation {
	static profileRoute: string = '/profile'

	static get route(): string {
		const translation = TranslationService.getInstance()
		return `/${translation.getLocale()}${this.profileRoute}/`
	}

	static toProfile(): void {
		this.navigateTo(this.route)
	}

	static toProfileStats(): void {
		this.navigateTo(`${this.route}?tab=stats`)
	}

	static toVisited(profileId?: string): void {
		const locale = TranslationService.getInstance().getLocale()
		let route = `/${locale}/profile/visited`
		if (profileId) route = `/${locale}/profiles/${profileId}/visited`
		this.navigateTo(route)
	}

	static toWishlist(profileId?: string): void {
		const locale = TranslationService.getInstance().getLocale()
		let route = `/${locale}/profile/wished`
		if (profileId) route = `/${locale}/profiles/${profileId}/visited`
		this.navigateTo(route)
	}
}
